import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [etat, setEtat] = useState(null);

  const rafraichirEtat = useCallback(() => api.get("/local/etat").then((r) => setEtat(r.data)).catch(() => setEtat({ local: false })), []);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    rafraichirEtat();
  }, [rafraichirEtat]);

  const ouvrirSession = useCallback((data) => {
    setUser(data.user);
  }, []);

  const signIn = useCallback(async (mode, payload) => {
    const { data } = await api.post(`/auth/${mode}`, payload);
    if (data.verification) return data;
    ouvrirSession(data);
    return null;
  }, [ouvrirSession]);

  const signOut = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, signIn, signOut, ouvrirSession, etat, rafraichirEtat }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const ProtectedRoute = ({ children }) => {
  const { user, etat } = useAuth();
  const { pathname } = useLocation();
  if (user === null || etat === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-700" />
      </div>
    );
  if (etat.local && !etat.compte) return <Navigate to="/bienvenue" replace />;
  if (!user) return <Navigate to="/login" replace />;
  if (etat.local && !etat.configure && pathname !== "/configuration") return <Navigate to="/configuration" replace />;
  if (!etat.local && pathname === "/configuration") return <Navigate to="/" replace />;
  return children;
};
